import React from "react";
import { esDieciocho } from "../../lib/dieciocho";

// Guirnalda de banderines del Dieciocho. Se dibuja en SVG con los colores de
// la bandera y se repite para cubrir el ancho, así que no pesa nada y escala.
//
// Por qué es sobria y no una guirnalda de fonda: MiPAE se abre en un turno.
// La fiesta se nota, pero no se le pone encima a nadie que está trabajando.
// Por eso va fina, arriba del todo, y nunca sobre contenido clínico.
//
// Los colores son los de la BANDERA y son fijos: azul, blanco y rojo, pase lo
// que pase con el tema (pedido del fundador, 2026-09-17). La primera versión
// sacaba el azul de `var(--accent)` y con el tema Café los banderines salían
// cafés, o sea dejaban de ser la bandera. Ahora salen de `--bandera-*`, que
// vive en index.css y no lo mueve ningún tema.
// Ninguno de los tres es un token clínico: `clinical-*` no se toca.
//
// Se retira solo fuera del 17 al 19 (fail-safe hacia no molestar) y queda
// quieto: no tiene animación, así que no hay nada que apagar bajo
// prefers-reduced-motion.
export default function Banderines({ className = "" }) {
  if (!esDieciocho()) return null;
  return (
    <div
      className={`w-full overflow-hidden ${className}`}
      data-testid="banderines"
      aria-hidden="true"
    >
      <svg
        className="w-full"
        height="18"
        viewBox="0 0 120 18"
        preserveAspectRatio="none"
        focusable="false"
      >
        <defs>
          {/* El trío azul, blanco y rojo que se repite a lo ancho. El blanco
              lleva un filo finito: sin él desaparece sobre el papel claro. */}
          <pattern id="mipae-banderines" width="30" height="18" patternUnits="userSpaceOnUse">
            <path d="M0 0 H9 L4.5 13 Z" fill="var(--bandera-azul)" />
            <path
              d="M10.5 0 H19.5 L15 13 Z"
              fill="var(--bandera-blanca)"
              stroke="var(--bandera-azul)"
              strokeWidth="0.9"
              strokeOpacity="0.85"
            />
            <path d="M21 0 H30 L25.5 13 Z" fill="var(--bandera-roja)" />
          </pattern>
        </defs>
        {/* El cordel. */}
        <rect x="0" y="0" width="120" height="1.4" fill="var(--edge-strong)" />
        <rect x="0" y="0" width="120" height="18" fill="url(#mipae-banderines)" />
      </svg>
    </div>
  );
}
